<div class="card overflow-hidden w-full">
  <div *ngIf="!driverPerformanceMetrics || !driverPerformanceMetrics.length" class="p-5">
    <div class="flex flex-nowrap overflow-x-auto gap-x-3">
      <div
        *ngFor="let _ of [1, 2, 3, 4, 5]; trackByIndex as i"
        class="flex flex-col h-[30vh] pt-7 items-center gap-y-2 p-2 w-10 shrink-0 animate-pulse"
      >
        <div class="relative w-full bg-gray-300 rounded" style="height: 200px"></div>
        <div class="w-16 h-4 bg-gray-300 rounded"></div>
        <div class="w-6 h-6 bg-gray-300 rounded-full"></div>
      </div>
    </div>
    <div class="mt-5 bg-gray-300 rounded h-16 animate-pulse"></div>
  </div>

  <div *ngIf="driverPerformanceMetrics?.length" class="w-full overflow-x-auto">
    <div class="flex flex-nowrap">
      <div class="inline-block h-[30vh] pr-5" *ngFor="let driver of driverPerformanceMetrics; trackBy: trackByDriver">
        <div
          class="flex flex-col h-full pt-7 items-center gap-y-2 p-2 cursor-pointer w-10 shrink-0 text-center"
          (click)="selectDriver(driver)"
          [ngClass]="{ 'bg-gray-300': selectedDriver?.driverId === driver.driverId }"
        >
          <div
            *ngIf="getBarInfo(driver) as barInfo"
            class="relative w-full"
            style="height: 300px; display: flex; flex-direction: column; align-items: center"
          >
            <div
              *ngIf="barInfo.missedPercent > 0"
              class="text-xs text-red-500 font-semibold"
              [style.bottom]="'calc(' + barInfo.missedPercent + '% + 1.9rem)'"
              style="position: absolute; white-space: nowrap; text-align: center"
            >
              -{{ driver.overallMissedRevenue | currencyInPennies }}
            </div>

            <div
              *ngIf="barInfo.missedPercent > 0"
              class="absolute bottom-0 bg-red-500"
              [style.height]="'calc(' + barInfo.missedPercent + '% + 1.75rem)'"
              style="width: 40px"
            ></div>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center; text-align: center; gap: 4px">
            <div
              style="
                font-size: 9px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 100px;
              "
            >
              {{ driver.driverName }}
            </div>
            <div>
              <img style="width: 20px; height: 20px" [alt]="driver.driverTier" [src]="driver.driverTier | typeBadge" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedDriver as driver" class="bg-gray-300 p-3">
    <div class="text-left text-xl font-semibold mb-4">
      {{ driver.driverName }}
    </div>
    <table class="w-full text-left border-collapse">
      <tbody>
        <tr *ngIf="driver.rejectedLoads?.totalMissedRevenue > 0">
          <td class="py-2 font-semibold align-top">Rejected Loads</td>
          <td class="py-2 align-top font-semibold">
            {{ driver.rejectedLoads?.totalLoadsRejected | number: '1.0-1' }} rejected loads
          </td>
          <td class="py-2 align-top">
            <div class="space-y-1">
              <div *ngIf="driver?.rejectedLoads?.orderDetailsFormatted?.length > 0; else noRejectedLoads">
                <div *ngFor="let load of driver.rejectedLoads.orderDetailsFormatted">
                  {{ load }}
                </div>
              </div>

              <ng-template #noRejectedLoads> - </ng-template>
            </div>
          </td>
          <td class="py-2 text-right align-top">
            {{ driver.rejectedLoads?.totalMissedRevenue | currencyInPennies }}
          </td>
        </tr>
        <tr *ngIf="driver.avgWastedTime?.totalMissedRevenue > 0">
          <td class="py-2 font-semibold" style="vertical-align: top">Avg. Wasted Time Per Load</td>
          <td class="py-2 font-semibold" style="vertical-align: top">
            {{ driver?.avgWastedTime?.totalAverageTimeWastedFormatted || '-' }}
          </td>

          <td class="py-2" style="vertical-align: top">
            <div *ngIf="driver?.avgWastedTime?.orders?.length > 0; else noOrders">
              <div style="margin-bottom: 0.25rem" *ngFor="let order of driver.avgWastedTime.orders">
                Wasted {{ order.orderTimeWastedFormatted }} on {{ order.orderId }}
              </div>
            </div>
            <ng-template #noOrders> - </ng-template>
          </td>
          <td class="py-2 text-right" style="vertical-align: top">
            {{ driver.avgWastedTime?.totalMissedRevenue | currencyInPennies }}
          </td>
        </tr>
        <tr *ngIf="driver.avgShiftDur?.totalMissedRevenue > 0">
          <td class="py-2 font-semibold align-top">Avg. Shift Duration</td>
          <td class="py-2 align-top font-semibold">
            {{ driver.avgShiftDur?.totalAvgShiftDurationFormatted }}
          </td>
          <td class="py-2 align-top">
            <div class="space-y-1">
              <div *ngFor="let detail of driver.avgShiftDur.shiftDetailsFormatted; trackBy: trackByDriver">
                {{ detail }}
              </div>
            </div>
          </td>
          <td class="py-2 text-right align-top">
            {{ driver.avgShiftDur.totalMissedRevenue | currencyInPennies }}
          </td>
        </tr>
        <tr *ngIf="driver.driverLosses?.totalMissedRevenue > 0">
          <td class="py-2 font-semibold">Lost Money from Low Tier</td>
          <td class="py-2 font-semibold">
            <span>{{ driver.driverTier }} tier</span>
          </td>
          <td class="py-2">
            <ng-container> Lost earnings by not being on Black Tier </ng-container>
          </td>
          <td class="py-2 text-right">
            {{ driver.driverLosses.totalMissedRevenue | currencyInPennies }}
          </td>
        </tr>
        <tr class="font-semibold">
          <td class="py-2">Total Missed Revenue</td>
          <td colspan="3" class="py-2 text-right text-base">
            {{ driver.overallMissedRevenue | currencyInPennies }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
